import React, {useReducer} from 'react';
import {AdvancedDeliveryContextType, defaultContext as initialContext} from './reducer/model';
import {advancedDeliveryReducer, AdvancedDeliveryType} from './reducer/index';
import {useAdvancedDeliveryContextAPI} from './hook/useAdvDContextAPI';
import {AdvancedDeliveryContext} from './reducer/context';
import {AdvancedDelivery} from './AdvancedDelivery';
import {CustomQueryClientProvider} from '../../hooks/useQueryClientProvider';

type Props = {
    onClose: () => void;
    zIndex: number;
    session: string;
    setIsScreenLocked: (isLocked: boolean) => void;
};

export const AdvancedDeliveryModule = (props: Props) => {
    // Initialize the state using useReducer
    const [state, dispatch] = useReducer<AdvancedDeliveryType, AdvancedDeliveryContextType>(
        advancedDeliveryReducer,
        initialContext,
        arg => arg
    );

    const contextHandlers = useAdvancedDeliveryContextAPI(dispatch, state);

    return (
        <CustomQueryClientProvider>
            <AdvancedDeliveryContext.Provider
                value={{
                    ...state,
                    ...contextHandlers
                }}
            >
                <AdvancedDelivery {...props} />
            </AdvancedDeliveryContext.Provider>
        </CustomQueryClientProvider>
    );
};
